/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Logo_AltInputs */

const en_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Caption Creator Logo`)
};

const fr_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de Closed Caption Creator`)
};

const de_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo für Untertitel-Ersteller`)
};

const it_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo del creatore dei sottotitoli`)
};

const ru_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип создателя субтитров`)
};

const es_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo del creador de subtítulos`)
};

const zh_cn2_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕创建器标志`)
};

const ja_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クローズドキャプションクリエイターロゴ`)
};

const hi_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर लोगो`)
};

const pt_pt2_app_logo_alt = /** @type {(inputs: App_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo do criador de legendas ocultas`)
};

/**
* | output |
* | --- |
* | "Closed Caption Creator Logo" |
*
* @param {App_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const app_logo_alt = /** @type {((inputs?: App_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_app_logo_alt(inputs)
	if (locale === "de") return de_app_logo_alt(inputs)
	if (locale === "it") return it_app_logo_alt(inputs)
	if (locale === "ru") return ru_app_logo_alt(inputs)
	if (locale === "es") return es_app_logo_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_app_logo_alt(inputs)
	if (locale === "ja") return ja_app_logo_alt(inputs)
	if (locale === "hi") return hi_app_logo_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_app_logo_alt(inputs)
	return en_app_logo_alt(inputs)
});